import styled from 'styled-components';

import { IconFilePDF } from '@xing-com/icons';
import { Label } from '@xing-com/label';
import {
  spaceS,
  spaceM,
  xdlColorTextSecondary,
  scale110,
  xdlColorBackgroundTertiary,
  spaceXL,
} from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

export const StyledLabel = styled(Label)<{ $active?: boolean }>`
  display: flex;
  gap: ${spaceM};
  width: 100%;
  padding: ${spaceM};
  background-color: ${({ $active }) =>
    $active ? xdlColorBackgroundTertiary : 'none'};
`;

export const StyledIcon = styled(IconFilePDF)`
  flex-shrink: 0;
  width: ${scale110};
`;

export const StyledTextWrapper = styled.span`
  display: flex;
  color: ${xdlColorTextSecondary};
  gap: ${spaceS};
`;

export const StyledText = styled(BodyCopy)`
  color: ${xdlColorTextSecondary};
  white-space: nowrap;
`;

export const StyledHeadline = styled(Headline)`
  overflow-wrap: anywhere;
  padding-right: ${spaceXL};
`;
